import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=1694a79e&scoped=true&"
import script from "./Certificate.vue?vue&type=script&lang=js&"
export * from "./Certificate.vue?vue&type=script&lang=js&"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=1694a79e&lang=scss&scoped=true&"
import style1 from "./Certificate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1694a79e",
  null
  
)

export default component.exports